import React from 'react';
import { Plane } from 'lucide-react';

export default function WizardLayout({ step, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-8" style={{ backgroundColor: 'var(--bg-dark)' }}>
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <Plane className="w-8 h-8" style={{ color: 'var(--neon)', strokeWidth: 1 }} />
          </div>
          <div className="text-sm font-light tracking-wide" style={{ color: 'var(--text-secondary)' }}>
            STEP {step} OF 5
          </div>
        </div>
        
        <div className="rounded-sm p-12" style={{ backgroundColor: 'var(--bg-card)', borderWidth: '1px', borderColor: 'var(--border)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}